module.exports = __webpack_public_path__ + "media/images/icon-search-9f2988f676519129489162acca96f54f.svg";